"use client";

import { createContext } from 'react';
const MenuContext = /*#__PURE__*/createContext({
  prefixCls: '',
  firstLevel: true,
  inlineCollapsed: false,
  styles: null,
  classNames: null
});
export default MenuContext;